import {
    START_LOADING,
    END_LOADING,
    TRANSALTE,
    ERROR_TRANSALTE,
} from "../actions/constants";

const initialState = {
    isLoading: false,
    translatedText: [],
    error: null,
};

const translation = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true, error: null, };
        case END_LOADING:
            return { ...state, isLoading: false };
        case TRANSALTE:
            return {
                ...state,
                translatedText: [...state.translatedText, action.payload],
            };
        case ERROR_TRANSALTE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default translation;